const AddDoctor = () => {
  return (
    <div style={{ width: "100%", textAlign: "center", paddingTop: "20px" }}>
      <h2>Under Construction...</h2>
    </div>
  );
};

export default AddDoctor;
